import React, { useState, useMemo, useImperativeHandle, } from "react";
import cx from "classnames";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { SolutionColorVariables } from "@smartsuite/types";
import { createPillPickerExtensions, } from "../../presets/pill-picker-preset";
import { Editor } from "../../react/Editor/Editor";
import { EditorInputGroup, } from "../EditorInputGroup/EditorInputGroup";
import { insertPillNode } from "../../extensions/pill/helpers";
export const PillPickerEditor = ({ children, renderEditorChildren, commandsRef, placeholder, maxLength, initialDoc, multiline, mode = "simple", buttonRef, isOpen, editorClassName = "", dashboardsStyle = false, onButtonClick, onStateChange, onFocus, onBlur, showAddButton = true, editable = true, ...rest }) => {
    const [view, setView] = useState();
    const extensions = useMemo(() => createPillPickerExtensions({
        multiline,
        maxLength,
        mode,
        placeholder: {
            placeholder,
            placeholderMode: "empty-doc",
        },
        dashboardsStyle,
        showToolbarButtonArrows: false,
        showToolbarButtonDividers: false,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useImperativeHandle(commandsRef, () => ({
        addPill: (attrs) => {
            insertPillNode(view, attrs);
        },
    }), [view]);
    const editorClasses = cx("pill-picker-editor__editor", editorClassName);
    return (React.createElement("div", { className: cx("pill-picker-editor", {
            "pill-picker-editor--multiline": multiline,
            "pill-picker-editor--disabled": !editable,
        }) },
        React.createElement(EditorInputGroup, { heightMode: "fixed", className: "pill-picker-editor__input-group", ...rest },
            React.createElement(Editor, { editable: editable, initialDoc: initialDoc, extensions: extensions, className: editorClasses, onViewCreated: setView, onStateChange: onStateChange, onFocus: onFocus, onBlur: onBlur }, renderEditorChildren),
            showAddButton && (React.createElement("button", { ref: buttonRef, className: "pill-picker-editor__plus-button", "data-testid": "pill-picker-editor__plus-button", tabIndex: -1, onClick: onButtonClick },
                React.createElement(Icon, { name: "plus-circle", size: "S", color: isOpen ? SolutionColorVariables.sc3 : SolutionColorVariables.sc1 }))),
            children)));
};
